import React, { useEffect, useState } from 'react';
import { subscribeApiLoading } from '../utils/ApiUtilities';

// App-wide loading indicator: a small spinning icon fixed in the top-right corner, shown
// whenever ANY API call is in flight (see ApiUtilities' request counter). Non-blocking
// (pointer-events: none) so it never interferes with the page underneath.
const GlobalLoadingIndicator = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => subscribeApiLoading(setLoading), []);

    if (!loading) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            style={{
                position: 'fixed',
                top: '0.75rem',
                right: '0.75rem',
                zIndex: 2000,
                pointerEvents: 'none',
            }}
        >
            <div
                className="spinner-border text-primary"
                style={{ width: '1.75rem', height: '1.75rem', borderWidth: '0.2rem' }}
            >
                <span className="visually-hidden">Loading…</span>
            </div>
        </div>
    );
};

export default GlobalLoadingIndicator;
